module.exports = __webpack_public_path__ + "static/media/webIcons_box.2a14f7b9.svg";